var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackboardAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V3H4C2.89543 3 2 3.89543 2 5V14C2 15.1046 2.89543 16 4 16H10.364L6.3897 21.5641C6.14894 21.9011 6.22701 22.3695 6.56407 22.6103C6.90113 22.8511 7.36954 22.773 7.6103 22.4359L12 16.2903L16.3897 22.4359C16.6305 22.773 17.0989 22.8511 17.4359 22.6103C17.773 22.3695 17.8511 21.9011 17.6103 21.5641L13.636 16H20C21.1046 16 22 15.1046 22 14V5C22 3.89543 21.1046 3 20 3H12.75V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboardAlt);
export default __webpack_public_path__ + "static/media/blackboard-alt.02425868140a6889c79f558b7a16b132.svg";
export { ForwardRef as ReactComponent };